import useUser from 'hooks/useUser'

type Props = {
  loading: boolean
}

const MerchantStatus = ({loading}: Props) => {
  const {user} = useUser()
  let merchant = user?.store
  return (
    <div>
      {' '}
      {merchant?.id &&
        !merchant?.is_approved &&
        !loading &&
        !merchant?.declined && (
          <div className="bg-red-600/50 rounded p-4 w-full mt-2">
            <i className="icon-exclamation mr-2" />
            Your store page is on its way! We're reviewing it now, please check
            back shortly.
          </div>
        )}
      {merchant?.declined && !loading && (
        <div className="bg-yellow-600/50 rounded p-4 w-full mt-2">
          <i className="icon-exclamation mr-2" />
          Your store page was declined with reason: {merchant?.decline_reason}
        </div>
      )}
    </div>
  )
}

export default MerchantStatus
